import React, { useEffect, useState } from "react";
import ConfigContext from "./ConfigContext";
import menuApi from "../../services/menuApi";
import promotionsApi from "../../services/promotionsApi";
import stringsApi from "../../services/stringsApi";

const ConfigProvider = ({ children }) => {
    const [menu, setMenu] = useState([])
    const [promotions, setPromotions] = useState([])
    const [strings, setStrings] = useState([])
    useEffect(() => {
        setupData()
    }, [])

    const setupData = async () => {
        let stringsResponse = null;
        try {
            stringsResponse = await stringsApi.fetchStrings();
        } catch (error) {
            console.error("fetchStrings", error);
        };
    }

    return (
        <ConfigContext.Provider value={{ strings }}>
            {children}
        </ConfigContext.Provider>
    );
};

export default ConfigProvider;